<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <div class="tag-title">公众号配置（h5）</div>
      <FormItem label="小程序appid" prop="wechat_appid">
        <Input style="width: 300px" v-model="form.wechat_appid" placeholder="请输入appid"></Input>
      </FormItem>
      <FormItem label="小程序secret" prop="wechat_secret">
        <Input style="width: 300px" v-model="form.wechat_secret" placeholder="请输入secret"></Input>
      </FormItem>
      <div class="tag-title">公众号配置（小程序）</div>
      <FormItem label="小程序appid" prop="min_appid">
        <Input style="width: 300px" v-model="form.min_appid" placeholder="请输入appid"></Input>
      </FormItem>
      <FormItem label="小程序secret" prop="min_secret">
        <Input style="width: 300px" v-model="form.min_secret" placeholder="请输入secret"></Input>
      </FormItem>
      <div class="tag-title">微信支付配置</div>
      <FormItem label="微信mchid" prop="mchid" key="mchid">
        <Input style="width: 300px" v-model="form.mchid" placeholder="请输入微信mchid"></Input>
      </FormItem>
      <FormItem label="微信key" prop="key" key="key">
        <Input style="width: 300px" v-model="form.key" placeholder="请输入微信key"></Input>
      </FormItem>
      <FormItem label="证书">
        <template v-if="form.certif == 0">
          <Upload
            :action="import_cert"
            :headers="headers"
            :on-error="uploadErr"
            :data="{ private: true, online: false }"
            :on-success="value => UploadSuccess('certif', value)"
            name="file"
            :show-upload-list="false"
          >
            <Button icon="ios-cloud-upload-outline">上传证书</Button>
          </Upload>
        </template>
        <template v-else>
          <div class="upload-info">已上传</div>
          <div>
            <Button type="primary" style="float: left; margin-right: 10px" @click="deleteCeat('certif')">
              删除证书
            </Button>
            <Upload
              :action="import_cert"
              :headers="headers"
              :on-error="uploadErr"
              :data="{ private: true, online: false }"
              :on-success="value => UploadSuccess('certif', value)"
              name="file"
              :show-upload-list="false"
            >
              <Button icon="ios-cloud-upload-outline" type="primary">重新上传</Button>
            </Upload>
          </div>
        </template>
        <span style="white-space: nowrap">
          证书下载路径：微信商户平台（
          <a href="https://pay.weixin.qq.com" rel="noopener" target="_blank">pay.weixin.qq.com</a>
          ）-->账户中心-->账户设置-->API安全 。
        </span>
      </FormItem>
      <FormItem label="证书密钥">
        <template v-if="form.certif_key == 0">
          <Upload
            :action="import_cert"
            :headers="headers"
            :data="{ private: true, online: false }"
            :on-error="uploadErr"
            :on-success="value => UploadSuccess('certif_key', value)"
            name="file"
            :show-upload-list="false"
          >
            <Button icon="ios-cloud-upload-outline">上传密钥</Button>
          </Upload>
        </template>
        <template v-else>
          <div class="upload-info">已上传</div>
          <div>
            <Button type="primary" style="float: left; margin-right: 10px" @click="deleteCeat('certif_key')">
              删除密钥
            </Button>
            <Upload
              :action="import_cert"
              :headers="headers"
              :data="{ private: true, online: false }"
              :on-error="uploadErr"
              :on-success="value => UploadSuccess('certif_key', value)"
              name="file"
              :show-upload-list="false"
            >
              <Button icon="ios-cloud-upload-outline" type="primary">重新上传</Button>
            </Upload>
          </div>
        </template>
        <span style="white-space: nowrap">
          证书下载路径：微信商户平台（
          <a href="https://pay.weixin.qq.com" rel="noopener" target="_blank">pay.weixin.qq.com</a>
          ）-->账户中心-->账户设置-->API安全 。
        </span>
      </FormItem>

      <div class="tag-title">消息推送配置</div>
      <FormItem label="令牌" prop="token">
        <Input style="width: 300px" v-model="form.token" placeholder="请输入令牌"></Input>
      </FormItem>
      <FormItem label="消息加密密钥" prop="aes_key">
        <Input style="width: 300px" v-model="form.aes_key" placeholder="请输入消息加密密钥"></Input>
        <div class="tips">
          <span style="white-space: nowrap">注:该配置影响微信自定义菜单及自动回复功能，请谨慎配置!</span>
          <span style="white-space: nowrap; display: block">
            服务器配置路径︰微信公众号平台（
            <a href="https://mp.weixin.qq.com" rel="noopener" target="_blank">mp.weixin.qq.com</a>
            ）-设置与开发-基本配置-服务器配置
          </span>
          <span style="white-space: nowrap">
            服务器地址：{{ apiData.service_url }}
            <a @click="getServiceUrl" v-if="!apiData.service_url">点击获取</a>
          </span>
        </div>
      </FormItem>
      <div class="tag-title">企业微信配置</div>
      <FormItem label="企业微信appid" prop="corp_id">
        <Input style="width: 300px" v-model="form.corp_id" placeholder="请输入企业微信appid"></Input>
      </FormItem>
      <FormItem label="企业微信secret" prop="corp_secret">
        <Input style="width: 300px" v-model="form.corp_secret" placeholder="请输入企业微信secret"></Input>
      </FormItem>
      <FormItem label="企业微信token" prop="corp_token">
        <Input style="width: 300px" v-model="form.corp_token" placeholder="请输入企业微信token"></Input>
      </FormItem>
      <FormItem label="企业微信密钥" prop="corp_aes_key">
        <Input style="width: 300px" v-model="form.corp_aes_key" placeholder="请输入企业微信密钥"></Input>
      </FormItem>
      <FormItem label="微信客服标识" prop="corp_user_id">
        <Input style="width: 300px" v-model="form.corp_user_id" placeholder="请输入微信客服标识"></Input>
      </FormItem>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
    <Button ghost type="primary" icon="ios-arrow-back" @click="$router.go(-1)">返回</Button>
  </div>
</template>

<script>
  import { apiGetSystem, apiSetSystem, apiGetSystemServiceUrl } from '@/api/organization'

  export default {
    name: 'add-form',
    data() {
      return {
        query: {},
        search: {},
        diyDom: {},
        // 表单数据
        form: {
          wechat_appid: '',
          wechat_secret: '',
          min_appid: '',
          min_secret: '',
          mchid: '',
          key: '',
          certif: '0', // 证书地址
          certif_key: '0', // 证书密钥
          token: '',
          aes_key: '',
          corp_id: '', //  企业微信appid
          corp_secret: '', //  企业微信secret
          corp_token: '', // 企业微信token
          corp_aes_key: '', //  企业微信密钥
          corp_user_id: '', // 微信客服标识
        },
        diyData: {
          rules: {
            wechat_appid: [{ required: true, message: '请输入appid', trigger: 'blur' }],
            wechat_secret: [{ required: true, message: '请输入secret', trigger: 'blur' }],
            min_appid: [{ required: true, message: '请输入appid', trigger: 'blur' }],
            min_secret: [{ required: true, message: '请输入secret', trigger: 'blur' }],
            mchid: [{ required: true, message: '请输入mchid', trigger: 'blur' }],
            key: [{ required: true, message: '请输入key', trigger: 'blur' }],
          },
        },
        apiData: {
          certif: '',
          certif_key: '',
          service_url: '',
        },
      }
    },
    computed: {
      import_cert() {
        return process.env.VUE_APP_API_URL + '/upload/file'
      },
      headers() {
        return {
          authorization: localStorage.getItem('token'),
        }
      },
    },
    methods: {
      // 获取配置
      getSettings() {
        this.$store.commit('setSpinShow', true)
        apiGetSystem(this.query.id, 'agency_wechat')
          .then(res => {
            const { wechat_appid, wechat_secret, mchid, key, certif, certif_key, token, aes_key } = res
            this.form.wechat_appid = wechat_appid
            this.form.wechat_secret = wechat_secret
            this.form.mchid = mchid
            this.form.key = key
            this.form.certif = certif ? certif : '0'
            this.form.certif_key = certif_key ? certif_key : '0'
            this.form.token = token
            this.form.aes_key = aes_key
            // 将当前的证书和秘钥复制一份
            this.apiData.certif = this.form.certif
            this.apiData.certif_key = this.form.certif_key
            this.form.min_appid = res.min_appid
            this.form.min_secret = res.min_secret
            this.form.corp_id = res.corp_id
            this.form.corp_secret = res.corp_secret
            this.form.corp_token = res.corp_token
            this.form.corp_aes_key = res.corp_aes_key
            this.form.corp_user_id = res.corp_user_id
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      UploadSuccess(type, res) {
        this.$Message.success('文件上传成功')
        if (type == 'certif') {
          this.form.certif = res.path
        } else if (type == 'certif_key') {
          this.form.certif_key = res.path
        }
      },
      uploadErr() {
        this.$Modal.error({
          title: '提示',
          content: '文件上传失败，请重试',
        })
      },
      deleteCeat(type) {
        for (let key in this.form) {
          if (type == key) {
            this.form[key] = '0'
          }
        }
      },
      submit() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.form.certif = this.form.certif == '0' ? '' : this.form.certif
            this.form.certif_key = this.form.certif_key == '0' ? '' : this.form.certif_key
            apiSetSystem(this.query.id, 'agency_wechat', {
              agency_wechat: this.form,
            }).then(() => {
              this.$Message.success('保存成功')
              this.getSettings()
            })
          }
        })
      },
      // 获取服务器地址
      getServiceUrl() {
        this.$store.commit('setSpinShow', true)
        apiGetSystemServiceUrl(this.query.id)
          .then(res => {
            this.apiData.service_url = res.url
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
    },

    mounted() {
      this.query = this.$route.query
      this.getSettings()
    },
  }
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      line-height: 19px;
      margin-bottom: 10px;
    }
  }
</style>
